<i18n src="@/common/i18n/i18n-locales.json"></i18n>

<template>
  <f7-actions>
    <f7-actions-group>
      <f7-actions-label>新增選項: {{ currentDraft[parentType][parentId].title }}</f7-actions-label>
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button @click="createQuestion({ type: questionType.radioQuestion, parentType, parentId, elementLevel })">
        {{ $t(`questionType.${questionType.radioQuestion}`) }}
      </f7-actions-button>
      <!-- <f7-actions-button>
        {{ $t(`questionType.${questionType.checkboxQuestion}`) }} (尚未完成)
      </f7-actions-button> -->
      <f7-actions-button @click="createQuestion({ type: questionType.switchQuestion, parentType, parentId, elementLevel })">
        {{ $t(`questionType.${questionType.switchQuestion}`) }}
      </f7-actions-button>
      <!-- <f7-actions-button>
        {{ $t(`questionType.${questionType.numberQuestion}`) }} (尚未完成)
      </f7-actions-button> -->
      <f7-actions-button @click="createQuestion({ type: questionType.numberGroupQuestion, parentType, parentId, elementLevel })">
        {{ $t(`questionType.${questionType.numberGroupQuestion}`) }}
      </f7-actions-button>
    </f7-actions-group>

    <f7-actions-group>
      <f7-actions-button color="red" bold>取消</f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CreateQuestionActionSheet',
  dependencies: ['questionType'],
  props: {
    storeIdProp: String,
    menuDraftVariationProp: String
  },
  computed: {
    ...mapState('menuDraftModule', ['currentElementPath', 'currentDraft']),
    parentType () { return this.currentElementPath.length > 3 ? 'options' : 'items' },
    parentId () { return (this.currentElementPath[4] || this.currentElementPath[2]).id },
    elementLevel () { return this.currentElementPath.length > 3 ? 5 : 3 }
  },
  methods: {
    ...mapActions('menuDraftModule', ['createQuestion'])
  }
}
</script>
